import { createSearchStore } from '@/stores/create-search-store';

export const useMemberSearchStore = createSearchStore({
  storeName: 'MemberSearchStore',
  defaultSortField: 'updatedAt',
  defaultItemsPerPage: 100,
});
